<template>
  <!-- ZPG-15: aba propria, so na tela de Despesas Diversos. O detailscollaborator (Processo de
       Desligamento) tambem e usado na tela de Viagem, entao o encerramento nao pode morar nele.
       No back o nome e "cancelamento" (emCancelamentoDiversos, rota CancelamentoDiversos). -->
  <div style="min-height: 200px;">
    <div v-if="employee">
      <b-form-group label="Código">
        <b-form-input v-model="employee.codigo" disabled></b-form-input>
      </b-form-group>
      <b-form-group label="Nome" class="mt-3">
        <b-form-input v-model="employee.nome" disabled></b-form-input>
      </b-form-group>
      <!-- Desligamento e encerramento sao exclusivos; depois do envio final o back nao deixa desfazer,
           porque o lote ja pode ter sido gerado com o acerto. -->
      <b-form-checkbox class="mt-3" switch v-model="employee.emCancelamentoDiversos" :disabled="employeeOrig.emProcessoDemissao || !!employeeOrig.dataEnvioCancelamentoDiversos">Em Encerramento de Diversos</b-form-checkbox>
      <b-button variant="third" class="mt-5" @click="onSave" v-if="employee.emCancelamentoDiversos !== employeeOrig.emCancelamentoDiversos">Salvar</b-button>
      <p class="aviso-info mt-3" v-if="employeeOrig.emProcessoDemissao">Funcionário em Processo de Desligamento: o encerramento de Diversos não se aplica.</p>
      <div class="mt-5" v-if="employee.emCancelamentoDiversos">
        <p class="aviso"><strong>ATENÇÃO</strong></p>
        <p class="aviso">Use para o funcionário que continua na empresa, mas não vai mais usar o Despesas Diversos. Será necessário solicitar ao funcionário o lançamento e o envio de todas as despesas em mãos. Após o próximo envio pelo Z-Pag não será mais possível enviar outras despesas. O acerto do adiantamento segue o do desligamento e, quando a Diretoria aprovar o lote, o acesso ao Despesas Diversos é encerrado.</p>
        <p class="aviso" v-if="employeeOrig.dataEnvioCancelamentoDiversos">Envio final feito em {{ formatDate(employeeOrig.dataEnvioCancelamentoDiversos) }}. Aguardando a aprovação do lote.</p>
      </div>
    </div>
    <p class="aviso-info" v-else>Selecione o colaborador no filtro ao lado.</p>
  </div>
</template>

<script>
import EmployeeRepository from '@/shared/http/repositories/business/employee'
import { loading, toast } from '@/shared/utils/UIHelper'
import CompanyMixin from '@/store/module/company/mixin'
import { clone } from 'lodash'

export default {
  name: 'EncerramentoDiversos',
  mixins: [CompanyMixin],
  data () {
    return {
      formSearch: {},
      employee: null,
      employeeOrig: null
    }
  },
  methods: {
    onLoad () {
      if (!this.formSearch.FuncionarioID) return
      loading.push()
      EmployeeRepository.GetById(this.formSearch.FuncionarioID)
        .then(response => {
          if (response.data.code > 0) {
            this.employeeOrig = response.data.data
            this.employee = clone(this.employeeOrig)
          }
        })
        .finally(() => loading.close())
    },
    onSave () {
      loading.push()
      EmployeeRepository.CancelamentoDiversos(this.employee.id, this.company.id, this.employee.emCancelamentoDiversos)
        .then(response => {
          this.employeeOrig = response.data
          this.employee = clone(this.employeeOrig)
          toast.success(this.employeeOrig.emCancelamentoDiversos ? 'Encerramento de Diversos iniciado' : 'Encerramento de Diversos desfeito')
        })
        .catch(error => {
          this.employee.emCancelamentoDiversos = this.employeeOrig.emCancelamentoDiversos
          toast.error((error.response && typeof error.response.data === 'string' && error.response.data) || 'Não foi possível salvar o Encerramento de Diversos')
        })
        .finally(() => loading.close())
    },
    formatDate (value) {
      return new Date(value).toLocaleString('pt-BR')
    }
  }
}
</script>

<style scoped>
p.aviso {
  font-size: 1.5rem;
  color: red;
  line-height: 2rem;
}
p.aviso-info {
  font-size: 1.2rem;
  color: #6c757d;
}
</style>



// WEBPACK FOOTER //
// src/views/private/miscellaneousreimbursement/components/encerramentodiversos/encerramentodiversos.vue